var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "vue-product-carousel", class: { zoomed: _vm.isZoomed } },
    [
      _c("div", { staticClass: "block-image" }, [
        _c("a", {
          staticClass: "main-image responsive-image",
          class: { "background-loading": _vm.bgLoading },
          style: _vm.mainImageStyle,
          attrs: { href: "#" },
          on: { click: _vm.toggleZoom, mousemove: _vm.onMouseMove }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "swipe-dots" },
          _vm._l(_vm.images, function(image, index) {
            return _c(
              "a",
              {
                key: index,
                staticClass: "btn-swipe",
                class: { selected: index === _vm.next },
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.onSlideClick(index)
                  }
                }
              },
              [_vm._v(_vm._s(index))]
            )
          }),
          0
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "block-details" }, [_vm._t("default")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }